import React from 'react'
import {
  Box,
  Checkbox,
  Divider,
  FormControlOwnProps,
  ListItemText,
  MenuProps,
} from '@mui/material'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import { colors } from '@resiliatech/birdsong'
import { useAppState } from 'Context/AppContext/AppContext'
import { sendFunderGoalChartViewedEvent } from '../utils'

const SELECT_WIDTH = '200px'
const inputLabelStyles = { color: colors.copy.paragraphDark }
const formControlStyles = { minWidth: SELECT_WIDTH, margin: '0 0 0 8px' }
const formControlProps: FormControlOwnProps = {
  size: 'small',
}
const selectStyles = {
  backgroundColor: colors.background.secondaryBackground,
  maxWidth: SELECT_WIDTH,
}

const menuProps: Partial<MenuProps> = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
}

type FilterValues = {
  nonprofitOrgNames: string[]
}

type ChartFiltersProps = {
  chartType: string
  filterValues: FilterValues
  setFilterValues: (filterValues: FilterValues) => void
  goalGroupId: number | null
  allNonprofitOrgNames: string[]
}

export const ChartFilters = ({
  chartType,
  filterValues,
  setFilterValues,
  goalGroupId,
  allNonprofitOrgNames,
}: ChartFiltersProps) => {
  const {
    funderOrgConfig: { orgId: funderOrgId },
    userConfig: { id: userId, email: userEmail },
  } = useAppState()

  const onFilterChange = (event: SelectChangeEvent<string | string[]>) => {
    const selectedValues = Array.isArray(event.target.value)
      ? event.target.value
      : [event.target.value]

    setFilterValues({
      ...filterValues,
      nonprofitOrgNames: selectedValues.includes('')
        ? []
        : selectedValues.filter(Boolean),
    })
    sendFunderGoalChartViewedEvent(
      selectedValues.includes('') ? 'Clear Filter' : selectedValues.join(', '),
      chartType,
      goalGroupId,
      userId,
      userEmail,
      funderOrgId
    )
  }

  return (
    <Box display='flex' justifyContent='flex-end' alignItems='center'>
      <FormControl sx={formControlStyles} {...formControlProps}>
        <InputLabel id='nonprofit-org-filter-label' sx={inputLabelStyles}>
          Grantees
        </InputLabel>
        <Select
          displayEmpty
          id='nonprofit-org-filter'
          labelId='nonprofit-org-filter-label'
          multiple
          onChange={onFilterChange}
          renderValue={(selected: string[]) =>
            selected.length === 0 ? 'Grantees' : selected.join(', ')
          }
          sx={selectStyles}
          value={filterValues.nonprofitOrgNames}
          MenuProps={menuProps}
        >
          <MenuItem value=''>Clear Filter</MenuItem>
          <Divider />
          {allNonprofitOrgNames?.map((orgName) => (
            <MenuItem key={orgName} value={orgName}>
              <Checkbox
                checked={filterValues.nonprofitOrgNames.includes(orgName)}
              />
              <ListItemText primary={orgName} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
